import { render, staticRenderFns } from "./ServiceSequenceTile.vue?vue&type=template&id=5b40c7c8&scoped=true"
import script from "./ServiceSequenceTile.vue?vue&type=script&lang=js"
export * from "./ServiceSequenceTile.vue?vue&type=script&lang=js"
import style0 from "./ServiceSequenceTile.vue?vue&type=style&index=0&id=5b40c7c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b40c7c8",
  null
  
)

export default component.exports